<template>
  <v-dialog v-model="dialog" :width="400">
      <v-card>
          <my-toolbar title="Add Status"></my-toolbar>
          <v-card-text>
              <v-autocomplete
              v-model="status"
                label="Add Status"
                :items="['Cost Discrepancy', 'Discount Cost Discrepancy', 'Quantity Discrepancy']"
              >
              </v-autocomplete>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" depressed outlined @click="dialog = false">Cancel</v-btn>
              <v-btn color="primary" depressed @click="handleSubmit">Submit</v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
export default {
    data: () => ({
        dialog: false,
        status: ''
    }),
    methods: {
        handleDialog(){
            this.dialog = !this.dialog
        },
        handleSubmit(){
            alert(this.status)
        }
    }
}
</script>